/* eslint-disable global-require */
const { de: common } = require("../../common");

module.exports = {
	...common,
};
